// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__erE6f","question":"styles_question__2tdlV","inputVisibleButton":"styles_inputVisibleButton__2e_sL","note":"styles_note__2uUlZ"};